/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit TysiaModalFooter/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import Children from 'Simple/Children'
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function TysiaModalFooter({
  children,
  viewPath = "/DesignSystem/TysiaModal/TysiaModalFooter",
  justifyContent = "flex-end",
  gap,
  onClose
  
}) {
let dtColorsWhite = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.white'
        })
let dtSpaceS = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.s'
        })
let dtColorsNeutral200 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.200'
        })
  return (<React.Fragment
>
<div
  data-testid="TysiaModalFooter.Horizontal"
  data-view-path={viewPath}
 style={{'--bc-1-2s2U8y': dtColorsWhite,'--pl-2-2s2U8y': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS,'--pr-3-2s2U8y': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS,'--pt-4-2s2U8y': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS,'--pb-5-2s2U8y': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS,'--jc-6-2s2U8y': justifyContent,'--btc-7-2s2U8y': dtColorsNeutral200,'--g-8-2s2U8y': typeof gap === 'number' ? `${gap}px` : gap}}
 className={`views-block ${styles.Horizontal}`}
>
<Children
  viewPath={`${viewPath}/Children`}
 onClose={onClose}
>
{children}
</Children>
</div>
</React.Fragment>)
}